<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div>
                            <h4 class="text-capitalize fw-500 breadcrumb-title mb-0">
                                <i class="fas fa-user-shield"></i> Login Google
                            </h4>
                            <small class="text-muted">Monitor daftar &amp; login (Google + email/OTP)</small>
                        </div>
                        <div class="action-btn d-flex align-items-center flex-wrap" style="gap:8px;">
                            <label class="mb-0 small text-muted">Tanggal (WIB):</label>
                            <input v-model="filterDate" type="date" class="form-control form-control-sm" style="width:auto;" @change="onDateChange" />
                            <button type="button" class="btn btn-sm btn-outline-secondary" @click="setToday">Hari ini</button>
                            <button @click="loadAll" class="btn btn-light"><i class="fas fa-sync"></i> Refresh</button>
                            <button type="button" class="btn btn-sm btn-outline-primary" @click="showTemplatePanel = !showTemplatePanel">
                                <i class="fas fa-envelope"></i> Template penawaran
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="showTemplatePanel" class="card p-3 mb-3">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <h6 class="mb-0">Template email penawaran</h6>
                    <button type="button" class="btn btn-sm btn-success" @click="openTemplateForm()"><i class="fas fa-plus"></i> Template baru</button>
                </div>
                <p v-pre class="small text-muted mb-2">Placeholder: {{name}}, {{email}}, {{nama}}. Template bertanda default dipakai saat kirim tanpa pilih template.</p>
                <div v-if="templatesLoading" class="small text-muted">Memuat template…</div>
                <div v-else-if="!offerTemplates.length" class="small text-muted">Belum ada template — buat minimal satu dan tandai sebagai default.</div>
                <table v-else class="table table-sm mb-0">
                    <thead>
                        <tr>
                            <th>Nama</th>
                            <th>Subject</th>
                            <th>Default</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="t in offerTemplates" :key="t.id">
                            <td>{{ t.name }}</td>
                            <td><small>{{ t.subject }}</small></td>
                            <td><span v-if="t.is_default" class="badge badge-success">default</span></td>
                            <td class="text-right text-nowrap">
                                <button type="button" class="btn btn-xs btn-outline-secondary btn-sm" @click="openTemplateForm(t)">Edit</button>
                                <button v-if="!t.is_default" type="button" class="btn btn-xs btn-outline-info btn-sm ml-1" @click="setDefaultTemplate(t.id)">Jadikan default</button>
                                <button type="button" class="btn btn-xs btn-outline-danger btn-sm ml-1" @click="deleteTemplate(t)">Hapus</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="templateFormOpen" class="card p-3 mb-3 border-primary">
                <h6 class="mb-2">{{ templateForm.id ? 'Edit template' : 'Template baru' }}</h6>
                <div class="form-group mb-2">
                    <label class="small">Nama</label>
                    <input v-model="templateForm.name" class="form-control form-control-sm" />
                </div>
                <div class="form-group mb-2">
                    <label class="small">Subject</label>
                    <input v-model="templateForm.subject" class="form-control form-control-sm" />
                </div>
                <div class="form-group mb-2">
                    <label class="small">HTML body (paste / import)</label>
                    <textarea v-model="templateForm.html_body" class="form-control" rows="10" style="font-family:monospace;font-size:12px;"></textarea>
                </div>
                <div class="form-check mb-2">
                    <input id="tplDefault" v-model="templateForm.is_default" type="checkbox" class="form-check-input" />
                    <label for="tplDefault" class="form-check-label small">Jadikan template default</label>
                </div>
                <div>
                    <button type="button" class="btn btn-sm btn-primary" :disabled="templateSaving" @click="saveTemplate">{{ templateSaving ? 'Menyimpan…' : 'Simpan' }}</button>
                    <button type="button" class="btn btn-sm btn-light ml-1" @click="closeTemplateForm">Batal</button>
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-md-3">
                    <div class="card p-3 text-center">
                        <small class="text-muted">Daftar baru ({{ dayLabel }})</small>
                        <h3 class="mb-0 text-success">{{ formatInt(summary.register) }}</h3>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card p-3 text-center">
                        <small class="text-muted">Login ({{ dayLabel }})</small>
                        <h3 class="mb-0 text-primary">{{ formatInt(summary.login) }}</h3>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card p-3 text-center">
                        <small class="text-muted">Link akun ({{ dayLabel }})</small>
                        <h3 class="mb-0 text-info">{{ formatInt(summary.link) }}</h3>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card p-3 text-center">
                        <small class="text-muted">Total akun (DB)</small>
                        <h3 class="mb-0 text-dark">{{ formatInt(usersDbTotal) }}</h3>
                        <small class="text-muted d-block mt-1">Google {{ formatInt(linkedAccountsTotal) }} · Email {{ formatInt(emailAccountsTotal) }}</small>
                    </div>
                </div>
            </div>

            <div v-if="summaryByMethod.google || summaryByMethod.email" class="card p-2 mb-3 small text-muted">
                <span class="mr-3"><b>{{ dayLabel }}</b> per metode:</span>
                <span class="mr-3">Google — daftar {{ formatInt(summaryByMethod.google.register) }}, login {{ formatInt(summaryByMethod.google.login) }}, link {{ formatInt(summaryByMethod.google.link) }}</span>
                <span>Email — daftar {{ formatInt(summaryByMethod.email.register) }}, login {{ formatInt(summaryByMethod.email.login) }}</span>
            </div>

            <div class="card p-3 mb-3">
                <h6 class="mb-2">Cek login terakhir</h6>
                <div class="row align-items-end">
                    <div class="col-md-5">
                        <label class="small text-muted mb-1">Email user</label>
                        <input
                            v-model="lastLoginEmail"
                            type="email"
                            class="form-control form-control-sm"
                            placeholder="user@example.com"
                            @keyup.enter="searchLastLogin"
                        />
                    </div>
                    <div class="col-md-auto">
                        <button type="button" class="btn btn-sm btn-primary" :disabled="lastLoginLoading" @click="searchLastLogin">
                            <i v-if="lastLoginLoading" class="fas fa-spinner fa-spin"></i>
                            <i v-else class="fas fa-search"></i>
                            Cari
                        </button>
                    </div>
                </div>
                <div v-if="lastLoginError" class="alert alert-warning py-2 px-3 mt-3 mb-0 small">{{ lastLoginError }}</div>
                <div v-else-if="lastLoginResult" class="border rounded p-3 mt-3 mb-0" style="background:#f9fafb;">
                    <div class="d-flex flex-wrap justify-content-between align-items-start" style="gap:8px;">
                        <div>
                            <strong>{{ lastLoginResult.name || '—' }}</strong>
                            <small class="text-muted d-block">{{ lastLoginResult.email }} · User ID {{ lastLoginResult.user_id }}</small>
                        </div>
                        <span v-if="lastLoginResult.source === 'log'" class="badge badge-light border">dari log aktivitas</span>
                        <span v-else-if="lastLoginResult.source === 'user_record'" class="badge badge-secondary">dari data akun (sebelum log)</span>
                        <span v-else class="badge badge-light border text-muted">belum tercatat</span>
                    </div>
                    <p class="mb-1 mt-2">
                        <span class="text-muted small">Login terakhir (WIB):</span>
                        <strong>{{ lastLoginResult.last_login_at ? formatTime(lastLoginResult.last_login_at) : '—' }}</strong>
                    </p>
                    <p v-if="lastLoginResult.auth_method" class="mb-1 small">
                        Metode: <span class="badge badge-light border">{{ lastLoginResult.auth_method }}</span>
                    </p>
                    <p v-if="lastLoginResult.client_ip || lastLoginResult.device_label" class="mb-0 small text-muted">
                        <span v-if="lastLoginResult.client_ip">{{ lastLoginResult.client_ip }}</span>
                        <span v-if="lastLoginResult.ip_region"> · {{ lastLoginResult.ip_region }}</span>
                        <span v-if="lastLoginResult.device_label" class="d-block mt-1">{{ lastLoginResult.device_label }}</span>
                    </p>
                </div>
            </div>

            <div class="card p-3 mb-3">
                <h6 class="mb-1">Aktivitas per hari (14 hari, WIB)</h6>
                <small class="text-muted d-block mb-2">Klik baris untuk filter tanggal</small>
                <table v-if="daily.length" class="table table-sm mb-0">
                    <thead>
                        <tr>
                            <th>Tanggal</th>
                            <th class="text-right">Daftar</th>
                            <th class="text-right">Login</th>
                            <th class="text-right">Link</th>
                            <th class="text-right">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in daily" :key="row.date_label" class="cursor-pointer" @click="pickDay(row.date_label)">
                            <td>{{ row.date_label }}</td>
                            <td class="text-right">{{ formatInt(row.register) }}</td>
                            <td class="text-right">{{ formatInt(row.login) }}</td>
                            <td class="text-right">{{ formatInt(row.link) }}</td>
                            <td class="text-right"><b>{{ formatInt(row.total) }}</b></td>
                        </tr>
                    </tbody>
                </table>
                <div v-else class="text-muted small">Belum ada log (event tercatat setelah fitur deploy).</div>
            </div>

            <ul class="nav nav-tabs mb-3">
                <li class="nav-item">
                    <a href="#" class="nav-link" :class="{ active: tab === 'events' }" @click.prevent="tab = 'events'">Log aktivitas</a>
                </li>
                <li class="nav-item">
                    <a href="#" class="nav-link" :class="{ active: tab === 'accounts' }" @click.prevent="switchAccounts">Semua akun</a>
                </li>
                <li class="nav-item">
                    <a href="#" class="nav-link" :class="{ active: tab === 'active' }" @click.prevent="switchActive">Login aktif</a>
                </li>
            </ul>

            <div v-show="tab === 'events'" class="card p-3 mb-3">
                <div class="row">
                    <div class="col-md-2">
                        <label class="small">Metode</label>
                        <select v-model="authMethodFilter" class="form-control form-control-sm" @change="loadLogs(1)">
                            <option value="">Semua</option>
                            <option value="google">Google</option>
                            <option value="email">Email</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label class="small">Event</label>
                        <select v-model="eventType" class="form-control form-control-sm" @change="loadLogs(1)">
                            <option value="">Semua</option>
                            <option value="register">register</option>
                            <option value="login">login</option>
                            <option value="link">link</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <label class="small">Email</label>
                        <input v-model="emailFilter" class="form-control form-control-sm" @keyup.enter="loadLogs(1)" />
                    </div>
                    <div class="col-md-2">
                        <label class="small">User ID</label>
                        <input v-model="userIdFilter" type="number" class="form-control form-control-sm" @keyup.enter="loadLogs(1)" />
                    </div>
                    <div class="col-md-3 d-flex align-items-end flex-wrap" style="gap:8px;">
                        <div class="form-check mb-0">
                            <input id="logOfferNotSent" v-model="offerEmailNotSent" type="checkbox" class="form-check-input" @change="loadLogs(1)" />
                            <label for="logOfferNotSent" class="form-check-label small">Belum dikirim penawaran</label>
                        </div>
                        <button class="btn btn-sm btn-primary" @click="loadLogs(1)"><i class="fas fa-search"></i> Cari</button>
                    </div>
                </div>
            </div>

            <div v-if="loading && tab !== 'active'" class="text-center p-5"><div class="spinner-border"></div></div>

            <div v-else>
            <div v-show="bulkBarVisible" class="row mb-2">
                <div class="col-12">
                    <div class="card p-2 d-flex flex-wrap align-items-center" style="gap: 10px">
                        <span class="small text-muted">{{ selectedCount }} dipilih (halaman ini{{ bulkDedupeHint }})</span>
                        <button
                            type="button"
                            class="btn btn-sm btn-primary"
                            :disabled="selectedCount === 0 || bulkSending"
                            @click="confirmBulkSendOffer"
                        >
                            <i class="fas fa-paper-plane"></i>
                            {{ bulkSending ? "Mengirim…" : "Kirim penawaran terpilih" }}
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="selectedCount === 0 || bulkSending" @click="clearBulkSelection">
                            Batal pilih
                        </button>
                        <small class="text-muted">Maks. 50 penerima per kirim (email duplikat digabung).</small>
                    </div>
                </div>
            </div>

            <div v-if="tab === 'events'">
                <div v-if="logs.length === 0" class="card p-4 text-center text-muted">Tidak ada log untuk filter ini.</div>
                <div v-else class="card p-0" style="overflow-x:auto;">
                    <table class="table table-hover mb-0" style="font-size:13px;">
                        <thead style="background:#f9fafb;">
                            <tr>
                                <th style="width:36px;">
                                    <input type="checkbox" :checked="allPageSelected" :disabled="!selectableOnPage.length" @change="toggleSelectAllPage" />
                                </th>
                                <th>Waktu</th>
                                <th>Metode</th>
                                <th>Event</th>
                                <th>User ID</th>
                                <th>Email</th>
                                <th>Paket</th>
                                <th>Kadaluarsa</th>
                                <th>IP</th>
                                <th>Penawaran</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="log in logs" :key="log.id">
                                <td>
                                    <input
                                        v-if="log.email"
                                        type="checkbox"
                                        :checked="isRowSelected(rowKeyLog(log))"
                                        @change="toggleRowSelected(rowKeyLog(log))"
                                    />
                                </td>
                                <td><small>{{ formatTime(log.created_at) }}</small></td>
                                <td><span class="badge badge-light border">{{ log.auth_method || 'google' }}</span></td>
                                <td><span class="badge" :class="badgeClass(log.event_type)">{{ log.event_type }}</span></td>
                                <td>{{ log.user_id }}</td>
                                <td><small>{{ log.email }}</small></td>
                                <td><small>{{ log.package_name || '-' }}</small></td>
                                <td><small>{{ formatTime(log.expired_at) }}</small></td>
                                <td>
                                    <small class="text-muted d-block">{{ log.client_ip || '-' }}</small>
                                    <small v-if="log.ip_region" class="text-muted d-block">{{ log.ip_region }}</small>
                                    <small v-if="log.device_label" class="text-muted d-block" style="opacity:.85;">{{ log.device_label }}</small>
                                </td>
                                <td>
                                    <span v-if="log.offer_email_sent" class="badge badge-secondary" :title="offerSentTitle(log)">
                                        <i class="fas fa-check-circle text-success"></i> Sudah dikirim
                                        <small v-if="log.offer_email_sent_at"> · {{ formatTime(log.offer_email_sent_at) }}</small>
                                    </span>
                                    <span v-else class="text-muted small">—</span>
                                </td>
                                <td>
                                    <button
                                        type="button"
                                        class="btn btn-xs btn-outline-primary btn-sm"
                                        :disabled="!log.email || sendingKey === sendKeyLog(log)"
                                        @click="sendOfferFromLog(log)"
                                    >
                                        Kirim email penawaran
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="logsTotal > logsLimit" class="d-flex justify-content-between align-items-center mt-2">
                    <small class="text-muted">{{ logsTotal }} baris</small>
                    <div>
                        <button class="btn btn-sm btn-outline-secondary" :disabled="logsPage <= 1" @click="loadLogs(logsPage - 1)">Prev</button>
                        <span class="mx-2 small">Hal {{ logsPage }}</span>
                        <button class="btn btn-sm btn-outline-secondary" :disabled="logsPage * logsLimit >= logsTotal" @click="loadLogs(logsPage + 1)">Next</button>
                    </div>
                </div>
            </div>

            <div v-else-if="tab === 'accounts'">
                <div class="card p-3 mb-3">
                    <div class="row">
                        <div class="col-md-2">
                            <label class="small">Metode akun</label>
                            <select v-model="accountAuthMethod" class="form-control form-control-sm" @change="loadAccounts(1)">
                                <option value="">Semua</option>
                                <option value="google">Google</option>
                                <option value="email">Email</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label class="small">Cari email</label>
                            <input v-model="accountEmail" class="form-control form-control-sm" @keyup.enter="loadAccounts(1)" />
                        </div>
                        <div class="col-md-4 d-flex align-items-end flex-wrap" style="gap:8px;">
                            <div class="form-check mb-0">
                                <input id="accOfferNotSent" v-model="offerEmailNotSent" type="checkbox" class="form-check-input" @change="loadAccounts(1)" />
                                <label for="accOfferNotSent" class="form-check-label small">Belum dikirim penawaran</label>
                            </div>
                            <button class="btn btn-sm btn-primary" @click="loadAccounts(1)">Cari</button>
                        </div>
                    </div>
                </div>
                <div v-if="accounts.length === 0" class="card p-4 text-center text-muted">Tidak ada akun untuk filter ini.</div>
                <div v-else class="card p-0" style="overflow-x:auto;">
                    <table class="table table-hover mb-0" style="font-size:13px;">
                        <thead style="background:#f9fafb;">
                            <tr>
                                <th style="width:36px;">
                                    <input type="checkbox" :checked="allPageSelected" :disabled="!selectableOnPage.length" @change="toggleSelectAllPage" />
                                </th>
                                <th>User ID</th>
                                <th>Nama</th>
                                <th>Email</th>
                                <th>Metode</th>
                                <th>Paket</th>
                                <th>Kadaluarsa</th>
                                <th>Status</th>
                                <th>Terdaftar</th>
                                <th>Penawaran</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="a in accounts" :key="a.user_id">
                                <td>
                                    <input
                                        v-if="a.email"
                                        type="checkbox"
                                        :checked="isRowSelected(rowKeyAccount(a))"
                                        @change="toggleRowSelected(rowKeyAccount(a))"
                                    />
                                </td>
                                <td>{{ a.user_id }}</td>
                                <td>{{ a.name }}</td>
                                <td><small>{{ a.email }}</small></td>
                                <td><span class="badge badge-light border">{{ a.auth_method || (a.google_id ? 'google' : 'email') }}</span></td>
                                <td><small>{{ a.package_name || '-' }}</small></td>
                                <td><small>{{ formatTime(a.expired_at) }}</small></td>
                                <td>{{ a.status === '1' ? 'aktif' : a.status }}</td>
                                <td><small>{{ formatTime(a.created_at) }}</small></td>
                                <td>
                                    <span v-if="a.offer_email_sent" class="badge badge-secondary" :title="offerSentTitle(a)">
                                        <i class="fas fa-check-circle text-success"></i> Sudah dikirim
                                        <small v-if="a.offer_email_sent_at"> · {{ formatTime(a.offer_email_sent_at) }}</small>
                                    </span>
                                    <span v-else class="text-muted small">—</span>
                                </td>
                                <td>
                                    <button
                                        type="button"
                                        class="btn btn-xs btn-outline-primary btn-sm"
                                        :disabled="!a.email || sendingKey === sendKeyAccount(a)"
                                        @click="sendOfferFromAccount(a)"
                                    >
                                        Kirim email penawaran
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="accountsTotal > accountsLimit" class="d-flex justify-content-between align-items-center mt-2">
                    <small class="text-muted">{{ accountsTotal }} akun</small>
                    <div>
                        <button class="btn btn-sm btn-outline-secondary" :disabled="accountsPage <= 1" @click="loadAccounts(accountsPage - 1)">Prev</button>
                        <span class="mx-2 small">Hal {{ accountsPage }}</span>
                        <button class="btn btn-sm btn-outline-secondary" :disabled="accountsPage * accountsLimit >= accountsTotal" @click="loadAccounts(accountsPage + 1)">Next</button>
                    </div>
                </div>
            </div>

            <div v-else-if="tab === 'active'">
                <div class="card p-3 mb-3 d-flex flex-wrap align-items-center justify-content-between" style="gap:12px;">
                    <div>
                        <span class="badge badge-primary mr-2">{{ formatInt(activeSessionsTotal) }} online</span>
                        <small class="text-muted">Sesi = access token valid di Redis (TTL ±24 jam)</small>
                    </div>
                    <div class="d-flex align-items-center flex-wrap" style="gap:8px;">
                        <div class="form-check mb-0">
                            <input id="activeAutoRefresh" v-model="autoRefreshActive" type="checkbox" class="form-check-input" @change="onAutoRefreshActiveChange" />
                            <label for="activeAutoRefresh" class="form-check-label small">Auto refresh 60 dtk</label>
                        </div>
                        <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="activeLoading" @click="loadActiveSessions">
                            <i class="fas fa-sync" :class="{ 'fa-spin': activeLoading }"></i> Refresh
                        </button>
                    </div>
                </div>
                <div v-if="activeLoading && !activeSessions.length" class="text-center p-5"><div class="spinner-border"></div></div>
                <div v-else-if="activeSessions.length === 0" class="card p-4 text-center text-muted">Tidak ada user dengan sesi login aktif saat ini.</div>
                <div v-else class="card p-0" style="overflow-x:auto;">
                    <table class="table table-hover mb-0" style="font-size:13px;">
                        <thead style="background:#f9fafb;">
                            <tr>
                                <th style="width:36px;">
                                    <input type="checkbox" :checked="allPageSelected" :disabled="!selectableOnPage.length" @change="toggleSelectAllPage" />
                                </th>
                                <th>User ID</th>
                                <th>Nama</th>
                                <th>Email</th>
                                <th>Metode</th>
                                <th>Sesi sejak</th>
                                <th>IP / device</th>
                                <th>Paket</th>
                                <th>Kadaluarsa</th>
                                <th>Penawaran</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="s in activeSessions" :key="s.user_id">
                                <td>
                                    <input
                                        v-if="s.email"
                                        type="checkbox"
                                        :checked="isRowSelected(rowKeyActive(s))"
                                        @change="toggleRowSelected(rowKeyActive(s))"
                                    />
                                </td>
                                <td>{{ s.user_id }}</td>
                                <td>{{ s.name }}</td>
                                <td><small>{{ s.email }}</small></td>
                                <td><span class="badge badge-light border">{{ s.auth_method || 'email' }}</span></td>
                                <td><small>{{ formatTime(s.login_at) }}</small></td>
                                <td>
                                    <small class="text-muted d-block">{{ s.client_ip || '-' }}</small>
                                    <small v-if="s.ip_region" class="text-muted d-block">{{ s.ip_region }}</small>
                                    <small v-if="s.device_label" class="text-muted d-block" style="opacity:.85;">{{ s.device_label }}</small>
                                </td>
                                <td><small>{{ s.package_name || '-' }}</small></td>
                                <td><small>{{ formatTime(s.expired_at) }}</small></td>
                                <td>
                                    <span v-if="s.offer_email_sent" class="badge badge-secondary" :title="offerSentTitle(s)">
                                        <i class="fas fa-check-circle text-success"></i> Sudah dikirim
                                        <small v-if="s.offer_email_sent_at"> · {{ formatTime(s.offer_email_sent_at) }}</small>
                                    </span>
                                    <span v-else class="text-muted small">—</span>
                                </td>
                                <td>
                                    <button
                                        type="button"
                                        class="btn btn-xs btn-outline-primary btn-sm"
                                        :disabled="!s.email || sendingKey === sendKeyActive(s)"
                                        @click="sendOfferFromActive(s)"
                                    >
                                        Kirim email penawaran
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'AdminGoogleAuth',
    data() {
        return {
            loading: false,
            tab: 'events',
            filterDate: '',
            summary: { register: 0, login: 0, link: 0, total: 0 },
            daily: [],
            linkedAccountsTotal: 0,
            usersDbTotal: 0,
            emailAccountsTotal: 0,
            summaryByMethod: { google: { register: 0, login: 0, link: 0 }, email: { register: 0, login: 0, link: 0 } },
            selectedDateLabel: '',
            authMethodFilter: '',
            accountAuthMethod: '',
            logs: [],
            logsPage: 1,
            logsLimit: 30,
            logsTotal: 0,
            eventType: '',
            emailFilter: '',
            userIdFilter: '',
            accounts: [],
            accountsPage: 1,
            accountsLimit: 30,
            accountsTotal: 0,
            accountEmail: '',
            offerEmailNotSent: false,
            showTemplatePanel: false,
            offerTemplates: [],
            templatesLoading: false,
            templateFormOpen: false,
            templateSaving: false,
            templateForm: { id: null, name: '', subject: '', html_body: '', is_default: false },
            sendTemplateId: '',
            sendingKey: '',
            bulkSending: false,
            bulkSelected: {},
            activeSessions: [],
            activeSessionsTotal: 0,
            activeLoading: false,
            autoRefreshActive: true,
            activeRefreshTimer: null,
            lastLoginEmail: '',
            lastLoginLoading: false,
            lastLoginResult: null,
            lastLoginError: '',
        };
    },
    computed: {
        dayLabel() {
            return this.selectedDateLabel || 'hari ini';
        },
        selectableOnPage() {
            if (this.tab === 'events') return this.logs.filter((l) => l.email);
            if (this.tab === 'accounts') return this.accounts.filter((a) => a.email);
            if (this.tab === 'active') return this.activeSessions.filter((s) => s.email);
            return [];
        },
        selectedCount() {
            return Object.keys(this.bulkSelected).length;
        },
        allPageSelected() {
            const rows = this.selectableOnPage;
            if (!rows.length) return false;
            return rows.every((r) => this.bulkSelected[this.rowKeyFor(r)]);
        },
        bulkBarVisible() {
            return this.selectedCount > 0;
        },
        bulkDedupeHint() {
            const unique = this.buildBulkItems(true).length;
            if (unique > 0 && unique < this.selectedCount) {
                return ` → ${unique} penerima unik`;
            }
            return '';
        },
    },
    watch: {
        tab(val) {
            this.clearBulkSelection();
            if (val === 'active') {
                this.startActiveAutoRefresh();
            } else {
                this.stopActiveAutoRefresh();
            }
        },
    },
    mounted() {
        this.setToday();
        this.loadOfferTemplates();
    },
    beforeDestroy() {
        this.stopActiveAutoRefresh();
    },
    methods: {
        setToday() {
            const d = new Date();
            const pad = (n) => String(n).padStart(2, '0');
            const wib = new Date(d.getTime() + (7 * 60 - d.getTimezoneOffset()) * 60000);
            this.filterDate = `${wib.getUTCFullYear()}-${pad(wib.getUTCMonth() + 1)}-${pad(wib.getUTCDate())}`;
            this.loadAll();
        },
        pickDay(label) {
            this.filterDate = label;
            this.loadAll();
        },
        onDateChange() {
            this.loadAll();
        },
        async loadAll() {
            this.loading = true;
            try {
                await Promise.all([this.loadStats(), this.loadLogs(this.logsPage)]);
            } finally {
                this.loading = false;
            }
        },
        async loadStats() {
            const r = await axios.get('admin/google-auth/stats', { params: { date: this.filterDate } });
            const d = r.data.data || {};
            this.summary = d.summary || { register: 0, login: 0, link: 0, total: 0 };
            this.daily = d.daily || [];
            this.linkedAccountsTotal = d.linked_accounts_total || 0;
            this.usersDbTotal = d.accounts_total || 0;
            this.emailAccountsTotal = d.email_accounts_total || 0;
            this.summaryByMethod = d.summary_by_auth_method || { google: { register: 0, login: 0, link: 0 }, email: { register: 0, login: 0, link: 0 } };
            this.selectedDateLabel = d.selected_date || this.filterDate;
        },
        async loadLogs(page) {
            this.logsPage = page || 1;
            const params = {
                date: this.filterDate,
                page: this.logsPage,
                limit: this.logsLimit,
            };
            if (this.authMethodFilter) params.auth_method = this.authMethodFilter;
            if (this.eventType) params.event_type = this.eventType;
            if (this.emailFilter) params.email = this.emailFilter;
            if (this.userIdFilter) params.user_id = this.userIdFilter;
            if (this.offerEmailNotSent) params.offer_email_not_sent = '1';
            const r = await axios.get('admin/google-auth/logs', { params });
            const d = r.data.data || {};
            this.logs = d.logs || [];
            this.logsTotal = d.total || 0;
        },
        switchAccounts() {
            this.tab = 'accounts';
            this.loadAccounts(1);
        },
        switchActive() {
            this.tab = 'active';
            this.loadActiveSessions();
        },
        onAutoRefreshActiveChange() {
            if (this.autoRefreshActive && this.tab === 'active') {
                this.startActiveAutoRefresh();
            } else {
                this.stopActiveAutoRefresh();
            }
        },
        startActiveAutoRefresh() {
            this.stopActiveAutoRefresh();
            if (!this.autoRefreshActive || this.tab !== 'active') {
                return;
            }
            this.activeRefreshTimer = setInterval(() => {
                if (this.tab === 'active' && !this.activeLoading) {
                    this.loadActiveSessions();
                }
            }, 60000);
        },
        stopActiveAutoRefresh() {
            if (this.activeRefreshTimer) {
                clearInterval(this.activeRefreshTimer);
                this.activeRefreshTimer = null;
            }
        },
        async loadActiveSessions() {
            this.activeLoading = true;
            try {
                const r = await axios.get('admin/google-auth/active-sessions');
                const d = r.data.data || {};
                this.activeSessions = d.sessions || [];
                this.activeSessionsTotal = d.total != null ? d.total : this.activeSessions.length;
            } catch (e) {
                this.activeSessions = [];
                this.activeSessionsTotal = 0;
            } finally {
                this.activeLoading = false;
            }
        },
        async searchLastLogin() {
            const email = String(this.lastLoginEmail || '').trim();
            if (!email || !email.includes('@')) {
                this.lastLoginError = 'Isi email yang valid.';
                this.lastLoginResult = null;
                return;
            }
            this.lastLoginLoading = true;
            this.lastLoginError = '';
            this.lastLoginResult = null;
            try {
                const r = await axios.get('admin/google-auth/last-login', { params: { email } });
                this.lastLoginResult = r.data.data || null;
            } catch (e) {
                const msg = (e.response && e.response.data && e.response.data.message) || e.message || 'Gagal memuat';
                this.lastLoginError = msg;
            } finally {
                this.lastLoginLoading = false;
            }
        },
        async loadAccounts(page) {
            this.accountsPage = page || 1;
            const params = { page: this.accountsPage, limit: this.accountsLimit };
            if (this.accountAuthMethod) params.auth_method = this.accountAuthMethod;
            if (this.accountEmail) params.email = this.accountEmail;
            if (this.offerEmailNotSent) params.offer_email_not_sent = '1';
            const r = await axios.get('admin/google-auth/accounts', { params });
            const d = r.data.data || {};
            this.accounts = d.accounts || [];
            this.accountsTotal = d.total || 0;
        },
        formatInt(n) {
            return Number(n || 0).toLocaleString('id-ID');
        },
        formatTime(ms) {
            if (!ms) return '-';
            return new Date(Number(ms)).toLocaleString('id-ID', { timeZone: 'Asia/Jakarta' });
        },
        badgeClass(type) {
            if (type === 'register') return 'badge-success';
            if (type === 'login') return 'badge-primary';
            if (type === 'link') return 'badge-info';
            return 'badge-secondary';
        },
        offerSentTitle(row) {
            const n = Number(row.offer_email_sent_count || 0);
            if (n > 1) return `Sudah ${n} kali dikirim`;
            return 'Email penawaran pernah dikirim';
        },
        async loadOfferTemplates() {
            this.templatesLoading = true;
            try {
                const r = await axios.get('admin/google-auth/offer-templates');
                this.offerTemplates = (r.data.data && r.data.data.templates) || [];
                const def = this.offerTemplates.find((t) => t.is_default);
                if (def && !this.sendTemplateId) {
                    this.sendTemplateId = String(def.id);
                }
            } catch (e) {
                this.offerTemplates = [];
            } finally {
                this.templatesLoading = false;
            }
        },
        openTemplateForm(t) {
            if (t) {
                this.templateForm = {
                    id: t.id,
                    name: t.name,
                    subject: t.subject,
                    html_body: t.html_body,
                    is_default: !!t.is_default,
                };
            } else {
                this.templateForm = { id: null, name: '', subject: '', html_body: '', is_default: !this.offerTemplates.length };
            }
            this.templateFormOpen = true;
            this.showTemplatePanel = true;
        },
        closeTemplateForm() {
            this.templateFormOpen = false;
        },
        async saveTemplate() {
            this.templateSaving = true;
            try {
                const body = {
                    name: this.templateForm.name,
                    subject: this.templateForm.subject,
                    html_body: this.templateForm.html_body,
                    is_default: this.templateForm.is_default,
                };
                if (this.templateForm.id) {
                    await axios.put(`admin/google-auth/offer-templates/${this.templateForm.id}`, body);
                    if (this.templateForm.is_default) {
                        await axios.post(`admin/google-auth/offer-templates/${this.templateForm.id}/default`);
                    }
                } else {
                    await axios.post('admin/google-auth/offer-templates', body);
                }
                this.closeTemplateForm();
                await this.loadOfferTemplates();
                alert('Template disimpan.');
            } catch (e) {
                const msg = (e.response && e.response.data && e.response.data.message) || e.message || 'Gagal menyimpan';
                alert(msg);
            } finally {
                this.templateSaving = false;
            }
        },
        async setDefaultTemplate(id) {
            try {
                await axios.post(`admin/google-auth/offer-templates/${id}/default`);
                await this.loadOfferTemplates();
            } catch (e) {
                alert((e.response && e.response.data && e.response.data.message) || 'Gagal set default');
            }
        },
        async deleteTemplate(t) {
            if (!confirm(`Hapus template "${t.name}"?`)) return;
            try {
                await axios.delete(`admin/google-auth/offer-templates/${t.id}`);
                await this.loadOfferTemplates();
            } catch (e) {
                alert((e.response && e.response.data && e.response.data.message) || 'Gagal hapus');
            }
        },
        offerSendErrorMessage(e) {
            let msg = (e.response && e.response.data && e.response.data.message) || '';
            msg = String(msg).trim();
            if (/^record not found$/i.test(msg)) {
                return 'Belum ada template penawaran default. Buat di panel Template penawaran.';
            }
            return msg || 'Gagal kirim email penawaran';
        },
        pickSendTemplateId() {
            if (this.offerTemplates.length <= 1) return this.sendTemplateId || undefined;
            const choice = window.prompt(
                `ID template (kosongkan = default):\n${this.offerTemplates.map((t) => `${t.id}${t.is_default ? ' (default)' : ''}: ${t.name}`).join('\n')}`,
                this.sendTemplateId || '',
            );
            if (choice === null) return null;
            return choice.trim() || undefined;
        },
        sendKeyLog(log) {
            return `log-${log.id}`;
        },
        sendKeyAccount(a) {
            return `acc-${a.user_id}`;
        },
        sendKeyActive(s) {
            return `active-${s.user_id}`;
        },
        rowKeyLog(log) {
            return this.sendKeyLog(log);
        },
        rowKeyAccount(a) {
            return this.sendKeyAccount(a);
        },
        rowKeyActive(s) {
            return this.sendKeyActive(s);
        },
        rowKeyFor(row) {
            if (this.tab === 'events') return this.rowKeyLog(row);
            if (this.tab === 'accounts') return this.rowKeyAccount(row);
            return this.rowKeyActive(row);
        },
        isRowSelected(key) {
            return !!this.bulkSelected[key];
        },
        toggleRowSelected(key) {
            const next = { ...this.bulkSelected };
            if (next[key]) delete next[key];
            else next[key] = true;
            this.bulkSelected = next;
        },
        toggleSelectAllPage(ev) {
            const on = ev.target.checked;
            const next = { ...this.bulkSelected };
            for (const r of this.selectableOnPage) {
                const k = this.rowKeyFor(r);
                if (on) next[k] = true;
                else delete next[k];
            }
            this.bulkSelected = next;
        },
        clearBulkSelection() {
            this.bulkSelected = {};
        },
        buildBulkItems(onlySelected) {
            let rows = [];
            if (this.tab === 'events') {
                rows = this.logs
                    .filter((log) => log.email && (!onlySelected || this.bulkSelected[this.rowKeyLog(log)]))
                    .map((log) => ({
                        email: log.email,
                        user_id: log.user_id || undefined,
                        name: log.name || '',
                    }));
            } else if (this.tab === 'accounts') {
                rows = this.accounts
                    .filter((a) => a.email && (!onlySelected || this.bulkSelected[this.rowKeyAccount(a)]))
                    .map((a) => ({
                        email: a.email,
                        user_id: a.user_id,
                        name: a.name || '',
                    }));
            } else if (this.tab === 'active') {
                rows = this.activeSessions
                    .filter((s) => s.email && (!onlySelected || this.bulkSelected[this.rowKeyActive(s)]))
                    .map((s) => ({
                        email: s.email,
                        user_id: s.user_id,
                        name: s.name || '',
                    }));
            }
            const seen = new Set();
            const items = [];
            for (const r of rows) {
                const dk = r.user_id ? `u:${r.user_id}` : `e:${String(r.email).toLowerCase()}`;
                if (seen.has(dk)) continue;
                seen.add(dk);
                items.push(r);
            }
            return items;
        },
        async confirmBulkSendOffer() {
            const items = this.buildBulkItems(true);
            if (!items.length) {
                alert('Pilih minimal satu baris yang punya email.');
                return;
            }
            const tplId = this.pickSendTemplateId();
            if (tplId === null) return;
            const tplLabel = tplId ? `template #${tplId}` : 'template default';
            let slice = items;
            if (items.length > 50) {
                if (!confirm(`Terpilih ${items.length} penerima unik; maks. 50 per kirim. Kirim 50 pertama dulu (${tplLabel})?`)) {
                    return;
                }
                slice = items.slice(0, 50);
            } else if (!confirm(`Kirim email penawaran ke ${slice.length} penerima (${tplLabel})?`)) {
                return;
            }
            this.bulkSending = true;
            let sent = 0;
            let failed = 0;
            try {
                const payload = { items: slice };
                if (tplId) payload.template_id = Number(tplId);
                const r = await axios.post('admin/google-auth/offer-email/send-bulk', payload);
                const d = (r.data && r.data.data) || {};
                sent = d.sent || 0;
                failed = d.failed || 0;
                alert(r.data.message || `Selesai: ${sent} terkirim`);
                this.clearBulkSelection();
                if (this.tab === 'events') await this.loadLogs(this.logsPage);
                else if (this.tab === 'accounts') await this.loadAccounts(this.accountsPage);
                else if (this.tab === 'active') await this.loadActiveSessions();
            } catch (e) {
                alert(this.offerSendErrorMessage(e));
            } finally {
                this.bulkSending = false;
            }
        },
        async sendOfferFromLog(log) {
            if (!log.email) return;
            const tplId = this.pickSendTemplateId();
            if (tplId === null) return;
            const tplLabel = tplId ? `template #${tplId}` : 'template default';
            if (!confirm(`Kirim email penawaran ke ${log.email} (${tplLabel})?`)) return;
            this.sendingKey = this.sendKeyLog(log);
            try {
                const payload = { email: log.email, user_id: log.user_id || undefined };
                if (tplId) payload.template_id = Number(tplId);
                const r = await axios.post('admin/google-auth/offer-email/send', payload);
                alert(r.data.message || 'Terkirim');
                await this.loadLogs(this.logsPage);
            } catch (e) {
                alert(this.offerSendErrorMessage(e));
            } finally {
                this.sendingKey = '';
            }
        },
        async sendOfferFromAccount(a) {
            if (!a.email) return;
            const tplId = this.pickSendTemplateId();
            if (tplId === null) return;
            const tplLabel = tplId ? `template #${tplId}` : 'template default';
            if (!confirm(`Kirim email penawaran ke ${a.email} (${tplLabel})?`)) return;
            this.sendingKey = this.sendKeyAccount(a);
            try {
                const payload = { email: a.email, user_id: a.user_id, name: a.name };
                if (tplId) payload.template_id = Number(tplId);
                const r = await axios.post('admin/google-auth/offer-email/send', payload);
                alert(r.data.message || 'Terkirim');
                await this.loadAccounts(this.accountsPage);
            } catch (e) {
                alert(this.offerSendErrorMessage(e));
            } finally {
                this.sendingKey = '';
            }
        },
        async sendOfferFromActive(s) {
            if (!s.email) return;
            const tplId = this.pickSendTemplateId();
            if (tplId === null) return;
            const tplLabel = tplId ? `template #${tplId}` : 'template default';
            if (!confirm(`Kirim email penawaran ke ${s.email} (${tplLabel})?`)) return;
            this.sendingKey = this.sendKeyActive(s);
            try {
                const payload = { email: s.email, user_id: s.user_id, name: s.name };
                if (tplId) payload.template_id = Number(tplId);
                const r = await axios.post('admin/google-auth/offer-email/send', payload);
                alert(r.data.message || 'Terkirim');
                await this.loadActiveSessions();
            } catch (e) {
                alert(this.offerSendErrorMessage(e));
            } finally {
                this.sendingKey = '';
            }
        },
    },
};
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }
.cursor-pointer:hover { background: #f3f4f6; }
</style>
